<template>
    <v-navigation-drawer fixed app v-model="twilioActive">
        <v-toolbar flat>
            <v-list>
                <v-list-item>
                    <v-list-item-title class="text-h6">
                        Video Call
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-toolbar>

        <div class="fill-height">
            <chat-video />
        </div>
    </v-navigation-drawer>
</template>

<script>
import ChatVideo from "@/components/ChatVideo.vue";

export default {
  computed: {
    twilioActive: {
      get() {
        return this.$store.state.application.twilioChat;
      },
      set(newVal) {
        if (!newVal) this.$store.commit("endTwilioChat");
      }
    }
  },

  components: {
    ChatVideo
  }
};
</script>
